const str = (v) => String(v ?? "").trim();

function parseMaybe(raw) {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
}

const emptyItem = () => ({ label: "", href: "", title: "" });

function navItems(src) {
  if (!Array.isArray(src)) return [];
  return src
    .map((item) => {
      const label = str(item?.label);
      const href = str(item?.href);
      if (!label || !href) return null;
      const title = str(item?.title);
      return title ? { label, href, title } : { label, href };
    })
    .filter(Boolean);
}

export function emptySiteNav() {
  return {
    format: "site_nav.v1",
    logoAlt: "",
    moreLabel: "",
    loginLabel: "",
    logoutLabel: "",
    logoutFullLabel: "",
    accountLabel: "",
    tripsLabel: "",
    openMenuLabel: "",
    closeMenuLabel: "",
    phone: { label: "", href: "", mobileLabel: "" },
    primary: [],
    more: [],
  };
}

export function sanitizeSiteNav(src) {
  const v = src && typeof src === "object" ? src : {};
  const phoneIn = v.phone && typeof v.phone === "object" ? v.phone : {};
  return {
    format: "site_nav.v1",
    logoAlt: str(v.logoAlt),
    moreLabel: str(v.moreLabel),
    loginLabel: str(v.loginLabel),
    logoutLabel: str(v.logoutLabel),
    logoutFullLabel: str(v.logoutFullLabel),
    accountLabel: str(v.accountLabel),
    tripsLabel: str(v.tripsLabel),
    openMenuLabel: str(v.openMenuLabel),
    closeMenuLabel: str(v.closeMenuLabel),
    phone: {
      label: str(phoneIn.label),
      href: str(phoneIn.href),
      mobileLabel: str(phoneIn.mobileLabel),
    },
    primary: navItems(v.primary),
    more: navItems(v.more),
  };
}

export function parseSiteNavFromContent(contentData) {
  const raw = parseMaybe(contentData?.conteudo_json);
  if (raw?.format === "site_nav.v1") return sanitizeSiteNav(raw);
  return emptySiteNav();
}

export { emptyItem as emptySiteNavItem };
